import React, { FC, useContext } from 'react'
import MobileDetect from 'mobile-detect'


export type MobileDetectorContextProps = {
	isMobile: boolean
	os?: () => string // return Android, ios, ...etc
	is?: (type: string) => boolean // sample is('iPhone'), is('bot'), ...etc
}


const MobileContext = React.createContext<MobileDetectorContextProps>({ isMobile: false })


export type MobileDetectorProviderProps = {
	userAgent: string
}


export const MobileDetectorProvider: FC<MobileDetectorProviderProps> = (props) => {
	const { userAgent, children } = props

	const md = new MobileDetect(userAgent)
	const isMobile = Boolean(md.mobile())

	const value: MobileDetectorContextProps = {
		isMobile: Boolean(md.mobile()),
		os: md.os,
		is: md.is,
	}

	return (
		<MobileContext.Provider value={value}>
			{children}
		</MobileContext.Provider>
	)
}


export const useMobileDetector = (): MobileDetectorContextProps => {
	return useContext(MobileContext)
}


